import React, { useContext, useState, useRef } from "react";

import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Modal from "@mui/material/Modal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CloseButton from "venuescanner-js/react/components/Buttons/CloseButton";
import templateQueries from "./queries";
import EditTemplateMessageInput from "./EditTemplateMessageInput";
import MessageInputProvider, {
  MessageInputContext,
} from "../MessageInput/MessageInputContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#fff",
  padding: "2rem",
  borderRadius: "1rem",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  width: "85vw",
  maxWidth: "820px",
};

const ManageTemplatesModalComponent = ({ ...props }) => {
  const nameInput = useRef();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { loadMessage } = useContext(MessageInputContext);
  const { data: templates } = templateQueries.all();
  const hasTemplates = Boolean(templates?.length);
  return (
    <Modal {...props}>
      <div style={style}>
        <CloseButton
          clickHandler={props.onClose}
          style={{ position: "absolute", top: "1rem", right: "1rem" }}
        />
        <Stack direction="row">
          <List>
            {hasTemplates ? (
              <ListItem
                style={{
                  opacity: "0.5",
                }}
              >
                Select template
              </ListItem>
            ) : null}
            {hasTemplates
              ? templates.map((template) => (
                  <ListItem
                    onClick={() => {
                      loadMessage(template);
                      setTimeout(() => {
                        nameInput.current.innerHTML = template.name;
                      });
                      setSelectedTemplate(template);
                    }}
                    title={template.content}
                    selected={selectedTemplate === template}
                    key={template._id}
                  >
                    {template.name}
                  </ListItem>
                ))
              : null}
          </List>
          <Divider
            orientation="vertical"
            flexItem
            style={{
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          />
          <EditTemplateMessageInput
            template={selectedTemplate}
            deselectTemplate={() => setSelectedTemplate(null)}
            nameInput={nameInput}
          />
        </Stack>
      </div>
    </Modal>
  );
};

const ManageTemplatesModal = ({ ...props }) => {
  return (
    <MessageInputProvider>
      <ManageTemplatesModalComponent {...props} />
    </MessageInputProvider>
  );
};
export default ManageTemplatesModal;
